// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"z0-z","subtitle":"A0-z","wrapper":"B0-z","leftArrow":"C0-z","rightArrow":"D0-z"};